import { render, staticRenderFns } from "./AddKPIModal.vue?vue&type=template&id=064866a8&scoped=true&"
import script from "./AddKPIModal.vue?vue&type=script&lang=js&"
export * from "./AddKPIModal.vue?vue&type=script&lang=js&"
import style0 from "./AddKPIModal.vue?vue&type=style&index=0&id=064866a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064866a8",
  null
  
)

export default component.exports